var map = {
	"./arunachal1.jpg": 2594,
	"./arunachal2.jpg": 4733,
	"./arunachal3.jpg": 7632,
	"./arunachal4.jpg": 2435,
	"./fire1.jpg": 4781,
	"./fire2.jpg": 8850,
	"./fire3.jpg": 559,
	"./isi1.jpg": 3732,
	"./isi2.jpg": 9011,
	"./isi3.jpg": 5846,
	"./isi4.jpg": 3661,
	"./isi5.jpg": 8080,
	"./isi6.jpg": 1695,
	"./voter1.jpeg": 326,
	"./voter2.jpeg": 5459,
	"./voter3.jpeg": 8780,
	"./voter4.jpeg": 9,
	"./voter5.jpeg": 5730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3368;